"use client";

import { c as _c } from "react/compiler-runtime";
import type { Client } from "@/lib/db/queries/clients";
import { getClient } from "@/app/actions/admin/client-actions";
import useSWR, { mutate } from "swr";
export interface ConsoleClientNavigation {
  clientId: string;
  name: string;
  voiceEnabled: boolean;
}
export function consoleClientNavigationFrom(client: Pick<Client, "id" | "name" | "settings">): ConsoleClientNavigation {
  return {
    clientId: client.id,
    name: client.name,
    voiceEnabled: client.settings?.realtimeVoiceEnabled === true || client.settings?.customVoicesEnabled === true
  };
}
type ConsoleClientNavigationKey = readonly [tag: "console-client-navigation", clientId: string];
function consoleClientNavigationKey(clientId: string): ConsoleClientNavigationKey {
  return ["console-client-navigation", clientId];
}
async function loadConsoleClientNavigation([, clientId]: ConsoleClientNavigationKey) {
  const result = await getClient(clientId);
  return result.success ? consoleClientNavigationFrom(result.data) : null;
}
export async function refreshConsoleClientNavigation(clientId: string): Promise<void> {
  await mutate(consoleClientNavigationKey(clientId));
}

/**
 * Shares the selected client's presentation-only navigation facts between
 * the sidebar and palette. Page and action authorization remains server-enforced.
 */
export function useConsoleClientNavigation(clientId) {
  const $ = _c(3);
  let t0;
  if ($[0] !== clientId) {
    t0 = clientId ? consoleClientNavigationKey(clientId) : null;
    $[0] = clientId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const key = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      shouldRetryOnError: false
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data
  } = useSWR(key, loadConsoleClientNavigation, t1);
  return data ?? null;
}